import { render, staticRenderFns } from "./AppBarParticipantWaitingRoom.vue?vue&type=template&id=4584c480"
import script from "./AppBarParticipantWaitingRoom.vue?vue&type=script&lang=js"
export * from "./AppBarParticipantWaitingRoom.vue?vue&type=script&lang=js"
import style0 from "./AppBarParticipantWaitingRoom.vue?vue&type=style&index=0&id=4584c480&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports